import React, { useEffect, useState, useCallback } from "react";
import { Alert } from "react-native";

const useCustomAlert = ({
  title,
  subTitle = "",
  cancelable = true,
  okText = "हाँ",
  onOkay = () => {},
  cancelText = "नहीं",
  onCancel = () => {},
  showCancel = true,
}) => {
  const buttons = showCancel
    ? [
        {
          text: cancelText,
          onPress: onCancel,
        },
        {
          text: okText,
          onPress: onOkay,
        },
      ]
    : [
        {
          text: okText,
          onPress: onOkay,
        },
      ];

  const handleShowAlert = () => {
    return Alert.alert(title, subTitle, buttons, { cancelable });
  };

  return [handleShowAlert];
};

export default useCustomAlert;
